const FILE_STATUS_MAX_PERCENT = 100
const SHOW_MESSAGE_DURATION = 5000
const STANDARD_DEBOUNCE_TIME = 750

export { FILE_STATUS_MAX_PERCENT, SHOW_MESSAGE_DURATION, STANDARD_DEBOUNCE_TIME }
